/*
  getRecaptchaEnterpriseToken retrieves a token from the Google
  Recaptcha Enterprise API. The token is typically added to
  the params of a form and sent to the back-end where it is
  assessed via another API call to Recaptcha Enterprise. The backend
  then decides whether the user is human or a bot based on the token.

  By default, the action encoded in the token is 'LOGIN'.

  If VUE_APP_RECAPTCHA_SITE_KEY or VUE_APP_RECAPTCHA_SECRET_KEY is
  undefined, or if VUE_APP_RECAPTCHA_ENABLED is not set to 'true',
  the function returns null.
*/

export async function getRecaptchaEnterpriseToken(action = 'LOGIN') {
  if (import.meta.env.VUE_APP_RECAPTCHA_ENABLED !== 'true') {
    return null;
  }

  if (!import.meta.env.VUE_APP_RECAPTCHA_SECRET_KEY) {
    return null;
  }

  if (!import.meta.env.VUE_APP_RECAPTCHA_SITE_KEY) {
    return null;
  }

  const loadRecaptcha = () => {
    return new Promise((resolve, _reject) => {
      const recaptchaScript = document.createElement('script');

      recaptchaScript.async = true;
      recaptchaScript.defer = true;
      recaptchaScript.onload = resolve;

      recaptchaScript.setAttribute(
        'src',
        'https://www.google.com/recaptcha/enterprise.js?render=' +
          import.meta.env.VUE_APP_RECAPTCHA_SITE_KEY,
      );

      recaptchaScript.type = 'text/javascript';
      document.head.appendChild(recaptchaScript);
    });
  };

  await loadRecaptcha();

  // eslint-disable-next-line no-undef
  if (!grecaptcha?.enterprise) {
    return null;
  }

  const waitForReady = new Promise((resolve, _reject) => {
    grecaptcha.enterprise.ready(resolve); // eslint-disable-line no-undef
  });

  await waitForReady;

  // eslint-disable-next-line no-undef
  const token = await grecaptcha.enterprise.execute(import.meta.env.VUE_APP_RECAPTCHA_SITE_KEY, {
    action,
  });

  return token;
}
